var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPropertyUpdated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.37 7.37L19 8L20.37 8.63L21 10L21.63 8.63L23 8L21.63 7.37L21 6L20.37 7.37ZM18 6L18.94 3.94L21 3L18.94 2.06L18 0L17.06 2.06L15 3L17.06 3.94L18 6Z",
    fill: "#248EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 4.5C8.16667 4.5 5 7.18333 5 11.3333C5 14.1 7.225 17.375 11.6667 21.1667C16.1083 17.375 18.3333 14.1 18.3333 11.3333C18.3333 7.18333 15.1667 4.5 11.6667 4.5ZM11.6667 12.8333C10.75 12.8333 10 12.0833 10 11.1667C10 10.25 10.75 9.5 11.6667 9.5C12.5833 9.5 13.3333 10.25 13.3333 11.1667C13.3333 12.0833 12.5833 12.8333 11.6667 12.8333Z",
    fill: "#248EB4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyUpdated);
export default __webpack_public_path__ + "static/media/property_updated.5abfa3b94f27a6b2f53f1df1433b82fb.svg";
export { ForwardRef as ReactComponent };